import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lh-shared-feature-empty-page',
  imports: [],
  templateUrl: './shared-feature-empty-page.component.html',
  styleUrl: './shared-feature-empty-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedFeatureEmptyPageComponent {}
